<template>
<div id="diagnostico_vucem" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12" >
        <base-material-card color="primary" icon="library_books" title="Diagnóstico WS-VUCEM" class="elevation-1 px-5 py-3" >
          <br>
          <v-card-text>
            <v-card-title>
              <span class="headline" ></span>
            </v-card-title>
            <v-form ref="form" lazy-validation>
              <v-container grid-list-md text-xs-center>
                <v-row>
                  <v-col sm="4" md="4" lg="3" >
                    <v-autocomplete v-model="model.tipo_reporte" :items="tipos_reporte" :hide-no-data="true" :hide-selected="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Reporte" :rules="[rules.required]" >
                    </v-autocomplete>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col sm="12" md="4" lg="3" >
                    <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                      <template v-slot:activator="{ on }" >
                        <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'" :rules="[rules.required, validaDias]" >
                        </v-text-field>
                      </template>

                      <v-date-picker v-model="model.fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                        <v-spacer />

                        <v-btn color="secondary" x-small @click="menu1 = false" >
                          Cancelar
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col sm="12" md="4" lg="3" >
                    <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                      <template v-slot:activator="{ on }" >
                        <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[rules.required, validaDias]" >
                        </v-text-field>
                      </template>

                      <v-date-picker v-model="model.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu2 = false" >
                        <v-spacer />

                        <v-btn color="secondary" x-small @click="menu2 = false" >
                          Cancelar
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="12" md="3" lg="3" >
                    <v-autocomplete v-model="model.tipo_operacion" :items="operaciones" :hide-no-data="true" :hide-selected="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Operación" :rules="[rules.required]" >
                    </v-autocomplete>
                  </v-col>
                  <v-col sm="12" md="3" lg="3" >
                    <v-autocomplete v-model="model.clave_pedimento" :items="claves" :hide-no-data="true" :hide-selected="true" :return-object="false" item-text="text" item-value="id" label="Clave de Pedimento" :rules="[rules.required]" >
                    </v-autocomplete>
                  </v-col>
                  <v-col sm="12" md="3" lg="3" >
                    <v-autocomplete v-model="model.tipo_pedimento" :items="tipos_pedimento" :hide-no-data="true" :hide-selected="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Pedimento" :rules="[rules.required]" >
                    </v-autocomplete>
                  </v-col>
                  <v-col sm="12" md="3" lg="3" >
                    <v-autocomplete v-model="model.identificador" :items="identificadores" :hide-no-data="true" :hide-selected="true" :return-object="false" item-text="text" item-value="id" label="Identificador Caso" :rules="[rules.required]" >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="12" md="2" lg="2" >
                    <v-card-actions>
                      <v-btn color="success" @click="tab=0;tipo=1;show_download=true;cargar()" >
                        <v-icon>done</v-icon>Generar Reporte
                      </v-btn>
                    </v-card-actions>
                  </v-col>
                  <v-col v-if="model.visible" sm="12" md="2" lg="2" style="margin-left:30px;" >
                    <exportar-excel :data="[datos]" name="DiagnosticoWS.xlsx" :tipo="2" >
                      <v-card-actions>
                        <v-btn color="warning" >
                          <v-icon>get_app</v-icon>Descargar Reporte
                        </v-btn>
                      </v-card-actions>
                    </exportar-excel>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>


          <v-tabs v-model="tab" v-if="model.visible" grow style="margin-bottom: 30px;" >
            <v-tabs-slider color="primary" ></v-tabs-slider>
            <v-tab :key="'general'" @click="tipo=1;" >Diagnóstico General</v-tab>
            <v-tab :key="'pedimentos'" @click="tipo=2;" >Pedimentos</v-tab>
            <v-tab :key="'coves'" @click="tipo=3;" >Coves</v-tab>
            <v-tab :key="'edocs'" @click="tipo=4;" >eDocuments</v-tab>
            <v-tab-item :key="'general'" >
              <div class="contenedor-tab-general" >
                <v-card-text>
                  <v-client-table id="algo" ref="vuetable" :data="datos.general" :columns="table_general.columns" :options="table_general.options" class="elevation-2 pa-2 scroll-table table_gen_centered" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>
                  </v-client-table>
                </v-card-text>
              </div>
            </v-tab-item>
            <v-tab-item :key="'pedimentos'" >
              <div class="contenedor-tab-pedimentos" >
                <v-card-text>
                  <v-client-table ref="vuetable" :data="datos.pedimentos" :columns="table_pedimentos.columns" :options="table_pedimentos.options" class="elevation-2 pa-2 scroll-table" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>
                  </v-client-table>
                </v-card-text>
              </div>
            </v-tab-item>
            <v-tab-item :key="'coves'" >
              <div class="contenedor-tab-coves" >
                <v-card-text>
                  <v-client-table ref="vuetable" :data="datos.coves" :columns="table_coves.columns" :options="table_coves.options" class="elevation-2 pa-2 scroll-table" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>
                  </v-client-table>
                </v-card-text>
              </div>
            </v-tab-item>
            <v-tab-item :key="'edocs'" >
              <div class="contenedor-tab-edocs" >
                <v-card-text>
                  <v-client-table ref="vuetable" :data="datos.edocs" :columns="table_edocs.columns" :options="table_edocs.options" class="elevation-2 pa-2 scroll-table" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>
                  </v-client-table>
                </v-card-text>
              </div>
            </v-tab-item>
          </v-tabs>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import XLSX from 'xlsx';

export default {
  components: {},
  created: function() {
    this.URL = this.$hostname + "reportes_ws/";
    this.loading = false;
    this.rfc = this.$local_storage.get("rfc");
    this.tipo = 1;
    this.get_claves_documento();
  },
  data: () => ({
    fab: false,
    rfc: '',
    tipo: '',
    tab: 0,
    menu1: false,
    menu2: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
          text: "E-Drive",
          disabled: true,
          to: ""
      },
      {
        text: "Diagnóstico WS-VUCEM",
        disabled: true,
        to: ""
      }
    ],
    model: {
      fecha_de: '',
      fecha_a: '',
      tipo_reporte: '1',
      tipo_operacion: 'Todas',
      clave_pedimento: 'Todas',
      tipo_pedimento: 'Todas',
      identificador: 'Todas',
      visible: false
    },
    datos: {
      resumen: [],
      pedimentos: [],
      coves: [],
      edocs: []
    },
    tipos_reporte: [{
      'id': "1",
      'text': 'Todos'
    }, {
      'id': "2",
      'text': 'Completos'
    }, {
      'id': "3",
      'text': 'Incompletos'
    }, ],
    claves: [{
      'id': 'Todas',
      'text': 'Todas las Claves'
    }],
    operaciones: [{
      'id': 'Todas',
      'text': 'Todas las Operaciones'
    }, {
      'id': '1',
      'text': 'Importaciones'
    }, {
      'id': '2',
      'text': 'Exportaciones'
    }],
    tipos_pedimento: [{
        'id': 'Todas',
        'text': 'Todas'
      },
      {
        'id': "1",
        'text': 1
      }, {
        'id': "2",
        'text': 2
      }
    ],
    identificadores: [{
      'id': 'Todas',
      'text': 'Todas'
    }, {
      'id': 'RC',
      'text': 'RC'
    }, {
      'id': 'PC',
      'text': 'PC'
    }],
    table_general: {
      columns: ["NoPedimento", "Fecha", "ClaveDocumento", "TipoOperacion", "TipoPedimento",
        "TotalCoves", "TotalRemesas", "TotaleDocs", "TotalPartidas", "DatosGenerales",
        "Partidas", "Remesas", "EstadosPedimento", "Coves", "eDocs",
        "AcusesCove", "AcusesEdocs", "AcusesRemesas", "TotalElementos", "AvanceTotal"
      ],
      options: {
        filterable: true,
        filterByColumn: false,
        texts: {
          filter: '',
          filterPlaceholder: 'Buscar',
        },
        headings: {
          NoPedimento: "No Pedimento",
          Fecha: "Fecha",
          ClaveDocumento: "Clave Documento",
          TipoOperacion: "Tipo Operacion",
          TipoPedimento: "Tipo Pedimento",
          TotalCoves: "Total de Coves",
          TotalRemesas: "Total de Remesas",
          TotaleDocs: "Total de eDocuments",
          TotalPartidas: "Total de Partidas",
          DatosGenerales: "DatosGenerales",
          Partidas: "Partidas",
          Remesas: "Remesas",
          EstadosPedimento: "Estado de Pedimento",
          Coves: "Coves",
          eDocs: "eDocuments",
          AcusesCove: "Acuses Cove",
          AcusesEdocs: "Acuses eDocs",
          AcusesRemesas: "Acuses Remesa",
          TotalElementos: "Conteo de Documentos",
          AvanceTotal: "Integración Total"
        }
      },
    },
    table_pedimentos: {
      columns: ["NoPedimento", "Fecha", "ClaveDocumento", "TipoOperacion", "Recuperable"],
      options: {
        filterable: false,
        headings: {
          NoPedimento: "No Pedimento",
          Fecha: "Fecha",
          ClaveDocumento: "Clave Documento",
          TipoOperacion: "Tipo Operacion",
          Recuperable: "Recuperable",
        }
      },

    },
    table_coves: {
      columns: ["NoPedimento", "eDocument", "Recuperable"],
      options: {
        filterable: false,
        headings: {
          NoPedimento: "No Pedimento",
          eDocument: "Cove",
          Recuperable: "Recuperable",
        }
      },

    },
    table_edocs: {
      columns: ["NoPedimento", "eDocument", "Recuperable"],
      options: {
        filterable: false,
        headings: {
          NoPedimento: "No Pedimento",
          eDocument: "eDocument",
          Recuperable: "Recuperable",
        }
      },

    },
    loading: false,
    show_loading: true,
  }),
  methods: {
    get_claves_documento: async function() {
      await axios.post(this.$hostname + "apendices/lista/", {
          tabla: 13
        }).then(res => {
          for (var i = 0; i < res.data.length; i++) {
            this.claves.push({
              'id': res.data[i].clave,
              'text': res.data[i].clave + ' ' + res.data[i].descripcion
            });
          }
        })
        .catch(err => {
          this.$swal({
            position: "center",
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el catálogo de claves"
          });
        });
    },
    cargar: function() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR...');
      let data = {
        rfc: this.rfc,
        tipo_reporte: this.model.tipo_reporte,
        fecha_de: this.model.fecha_de,
        fecha_a: this.model.fecha_a,
        tipo_operacion: this.model.tipo_operacion,
        clave_documento: this.model.clave_pedimento,
        tipo_pedimento: this.model.tipo_pedimento,
        identificador: this.model.identificador
      };

      axios.post(this.URL + "diagnostico_vucem/", data)
        .then(res => {
          this.model.visible = true;
          if (typeof res.data !== "undefined") {
            this.datos = res.data;
          }
        })
        .catch(err => {
          
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    validaDias: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days');
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial.";
        if (Math.abs(diferencia) > 366)
          return "Periodo máximo de consulta un año. Favor de verificar.";
      }
      return true;
    },
  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small ;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small ;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
  text-align: center !important;
}

#algo {
  text-align: center !important;
}
</style>
